import React,{useState,useEffect} from "react";
import Slider from '@material-ui/core/Slider';
import { withStyles} from '@material-ui/core/styles';

const StyledSlider=withStyles({
  root: {
    color: 'var(--primary-color-600)',
  },
  track:{
    height:8
  },
  rail:{
    height:8
  },
  active: {},
  thumb:{
    marginTop:-5,
    width:3,
    borderRadius:0,
    height:18,
    marginLeft:0,
    color:"#aaa",
    '&:focus,&:hover,&$active': {
        boxShadow: "none",
      },
  },
  valueLabel: {
    left:"calc(-50% + -12px)",
    top: -22,
    '& *': {
     background: 'transparent',
     color: '#000',
   },
  }
})(Slider);


function getRangeV2(matchingFilterString,filterType){
  let bottomRange=filterType.min;
  let topRange=filterType.max;
  matchingFilterString.forEach((item, i) => {
    if(item[0]===">"){
      bottomRange=Number(item.substring(1));
    }
    else if(item[0]==="<"){
      topRange=Number(item.substring(1));
    }
  });
  return([bottomRange,topRange])
}




function SliderFilter(props){
  let [sliderValues,setSliderValues]=useState(getRangeV2(props.matchingFilterString,props.filterType));

  useEffect(()=>{
    setSliderValues(getRangeV2(props.matchingFilterString,props.filterType))
  },[props.matchingFilterString,props.filterType])


  const handleChange = (event, newValue) => {
    setSliderValues(newValue);
  };

  const createFiltersV2 = ()=>{
    let returnFilters=[];
    if(sliderValues[0]!==props.filterType.min){
      returnFilters.push(">" + sliderValues[0]);
    }

    if(sliderValues[1]!==props.filterType.max){
      returnFilters.push("<" + sliderValues[1]);
    }

    props.updateFilters(returnFilters,props.filterType.data)
  }


  return(
    <div style={{padding:"20px 0px 10px"}}>
      <StyledSlider
        value={sliderValues}
        min={props.filterType.min}
        max={props.filterType.max}
        step={props.filterType.step}
        valueLabelFormat={(x)=>x}
        onChange={handleChange}
        onChangeCommitted={createFiltersV2}
        valueLabelDisplay="on"
        aria-labelledby="range-slider"
        />
    </div>
  )
}

export default SliderFilter;
